module.exports = __webpack_public_path__ + "static/media/product (3).39a4d51b.jpg";